const Terms2 = () => {
	return (
		<div className="terms-content">
			<div className="terms-box">
				<h4 className="terms-title">제 1 조 (목적)</h4>
				<p>
					본 약관은 주식회사 핑거 (이하 '회사')가 제공하는 스텔라 서비스 이용과 관련하여, 인터넷 사이 트(
					<a href="https://stella-erp.co.kr/" className="text-link" target="_blank" title="새창 열림" rel="noreferrer">
						www.stella-erp.co.kr
					</a>
					)(이하 ‘스텔라 사이트’)를 이용함에 있어, 회사와 이용자 간 권리와 의무 및 책임사항 등 기타 제반사항을 규정함을
					목적으로 합니다.
				</p>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 2 조 (용어의 정의)</h4>
				<p>
					본 약관에서 사용하는 용어의 정의는 다음과 같습니다. 본 약관에서 정의하지 않은 것은 관련 법 령 및 서비스 별
					안내에서 정하는 바에 따르며, 그 외에는 일반 관례에 따릅니다.
				</p>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>“스텔라 사이트”라 함은 ”회사”가 “이용자”에게 제공하는 비즈니스웨어 플랫폼인 “스텔라 서
						비스”를 홍보할 수 있도록 설정한 웹사이트를 의미합니다.
					</li>
					<li className="depth">
						<span>2.</span>"이용자"라 함은 “스텔라 사이트”에 접속하여 이 약관에 따라 서비스를 이용하는 자를 말합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 3 조 (이용약관의 효력 및 적용과 변경)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>“스텔라 사이트”의 약관에는 이용자가 회사의 정보를 알 수 있도록 하단에 정보를 명시하고, 실제
						서비스 사이트로 연결될 수 있도록 하며, 가입 시 회원을 위한 세부 약관을 볼 수 있도록 할 수 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>회사는 합리적인 사유가 발생할 경우 관련 법령에 위배되지 않는 범위 내에서 약관을 개정 할 수
						있습니다. 개정된 약관은 사이트를 통해 공지하고 최소한 7일 전에 고지합니다. 다만, 이 용자에게 불리하게
						약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 고지합니다. 이 경우 개정 전과 개정 후
						내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시 합니다.
					</li>
					<li className="depth">
						<span>3.</span>“스텔라 사이트”를 통해 공지된 변경된 약관에 대한 정보를 알지 못해 발생하는 회원의 피해 는
						회사에서 책임지지 않습니다.
					</li>
					<li className="depth">
						<span>4.</span>이 약관에 명시되지 아니한 사항과 이 약관의 해석에 관하여는 약관의 규제에 관한 법률, 전
						기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등의 관계법령 또는 상관례에
						따릅니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 4 조 (약관 외 준칙)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>회사는 필요한 경우 기타 유ㆍ무료 서비스 내의 운영원칙 또는 개별약관(이하 '서비스 별 약
						관'이라 합니다)을 정할 수 있으며, 본 약관과 서비스 별 약관의 내용이 상충되는 경우에는 서비스 별 약관의
						내용을 우선하여 적용합니다.
					</li>
					<li className="depth">
						<span>2.</span>이 약관에 명시되지 아니한 사항은 약관의 규제에 관한 법률, 전기통신기본법, 전기통신사업법,
						정보통신망 이용촉진 및 정보보호 등에 관한 법률 등의 관계법령 또는 상관례에 따릅니다
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 5 조 (서비스의 제공 및 변경)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>“스텔라 사이트”는 스텔라 서비스에 대한 정보 제공 및 고객 서비스 관련 사항, 기타 필요한 정보를
						제공합니다.
					</li>
					<li className="depth">
						<span>2.</span>“스텔라 사이트”는 이용자가 서비스 이용 중 필요하다고 인정되는 다양한 정보에 대해서 전자
						메일이나 등의 방법으로 회원에게 제공할 수 있으며, 이용자가 원하지 않을 경우 거부를 할 수 있습니다. 단,
						서비스의 종료, 중단 기타 서비스 내용에 중대한 변경 등의 사유가 있을 경우 에는 회원의 수신거부의사에도
						불구하고 해당 내용을 제공할 수 있습니다.
					</li>
					<li className="depth">
						<span>3.</span>“스텔라 사이트”는 정보통신설비의 보수 점검, 교체 및 고장, 통신 두절 등의 사유가 발생한
						경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 6 조 (개인정보의 보호)</h4>
				<p>
					회사는 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에
					관해서는 관계 법령 및 회사의 개인정보처리방침에 정한 바에 의합니다.
				</p>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>“스텔라 사이트”는 이용자의 정보 수집 시 고객 서비스에 필요한 최소한의 정보를 수집하여 이를
						가공, 보관, 관리할 수 있습니다. 이 경우 수집되는 정보는 다음 사항을 필수 사항으로 하 며 그 외 사항은 선택
						사항으로 합니다.
						<ul className="bullet-dash">
							<li className="bullet">회사명, 이름, 연락처, 이메일</li>
						</ul>
					</li>
					<li className="depth">
						<span>2.</span>“스텔라 사이트”를 통해 서비스 문의 및 제휴 문의를 할 경우 이용자는 개인정보를 수집하는 것에
						대한 동의를 하여야 합니다.
					</li>
					<li className="depth">
						<span>3.</span>제공된 개인정보는 이용자의 동의 없이 목적 외의 이용이나 제 3자에게 제공하지 않습니다. 다만
						다음의 경우에는 예외로 합니다.
						<ol className="terms-depth">
							<li className="depth">
								<span>1)</span>개인정보 도용방지를 위하여 본인확인에 필요한 경우
							</li>
							<li className="depth">
								<span>2)</span>도용방지를 위하여 본인확인에 필요한 경우
							</li>
						</ol>
					</li>
					<li className="depth">
						<span>4.</span>“스텔라 사이트” 또는 그로부터 개인정보를 제공받은 제 3자는 개인 정보의 수집 목적 또는 제공
						받는 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 7 조 (“스텔라 사이트”의 의무)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>“스텔라 사이트”는 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 지속적,
						안정적으로 서비스를 제공하기 위해 노력할 의무가 있습니다.
					</li>
					<li className="depth">
						<span>2.</span>“스텔라 사이트”는 이용자의 개인정보를 본인의 승낙 없이 타인에게 누설, 배포하지 않습니다.
						다만, 전기통신관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다.
					</li>
					<li className="depth">
						<span>3.</span>“스텔라 사이트”는 이용자가 안전하게 홈페이지의 서비스를 이용할 수 있도록 법률을 준수하며,
						이용자가 원하지 않는 영리 목적의 광고성 전자 우편 등을 발송하지 않습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 8 조 (이용자의 의무)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>이용자는 타인의 정보를 도용하여서는 안됩니다.
					</li>
					<li className="depth">
						<span>2.</span>이용자는 사전 승낙 없이 서비스를 이용한 어떠한 영리행위도 할 수 없습니다.
					</li>
					<li className="depth">
						<span>3.</span>이용자는 “스텔라 사이트”를 이용하여 얻은 정보를 회사의 사전승낙 없이 복사, 복제, 변경, 번역,
						출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">제 9 조 (준거법 및 관할법원)</h4>
				<ol className="terms-depth">
					<li className="depth">
						<span>1.</span>이 약관의 해석·적용에 관하여는 대한민국법을 적용합니다.
					</li>
					<li className="depth">
						<span>2.</span>본 사이트 이용과 관련하여 분쟁이 발생할 경우에는 회사의 본점 소재지를 관할하는 법원으로
						합니다.
					</li>
				</ol>
			</div>
			<div className="terms-box">
				<h4 className="terms-title">[부칙]</h4>
				<p>본 약관은 2025년 04월 10일부터 시행합니다.</p>
			</div>
			<div className="terms-box">
				<p>시행 일자: 2025년 04월 10일</p>
			</div>
		</div>
	);
};

export default Terms2;
